<template>
  <div class="pedido-processo-listagem">
    <PedidoProcessoIntroducao
      titulo="Planejamento e pedidos de materiais"
      descricao="Consulte eventos, períodos e responsáveis e acompanhe a evolução de cada solicitação."
      icon="mdi-toolbox-outline"
    />
    <ListagemBase
      nomePlural="PedidoMateriais"
      nomeSingular="PedidoMaterial"
      :headers="headers"
      :pesquisaDetalhe="true"
      :pesquisaPeriodo="true"
      :buscaSimplificada="false"
      :buscaParametrizadaPaginada="true"
      :pesquisaStatusPedidosMateriais="true"
      stringCadastro="Nova_solicitacao"
      :opcoesLegenda="[
        { text: 'Pendente', color: 'orange' },
        { text: 'Concluído', color: 'green' },
      ]"
    >
      <template v-slot:upload> </template>
    </ListagemBase>
  </div>
</template>

<script>
import ListagemBase from "@/components/base/Crud/ListagemBase";
import PedidoProcessoIntroducao from "@/components/recursos/pedido-layout/PedidoProcessoIntroducao";
import DataService from "@/services/recursos/PedidoMaterialDataService";

export default {
  name: "ListagemPedidos",
  components: { ListagemBase, PedidoProcessoIntroducao },
  data() {
    return {
      DataService: DataService,
      headers: [
        { text: this.$t("Status"), value: "statusPedido", sortable: "false" },
        {
          text: this.$t("Data_do_evento"),
          value: "dataPedido",
          sortable: "false",
        },
        {
          text: this.$t("Descrição"),
          value: "descricao",
          sortable: "false",
        },
        {
          text: this.$t("dataSolicitacao"),
          value: "dtInclusao",
          sortable: "false",
        },
        {
          text: this.$t("Solicitante"),
          value: "solicitante.nome",
          sortable: "false",
        },
        {
          text: this.$t("Atividade"),
          value: "actionsPedidoMaterial",
          sortable: "false",
        },
        { text: this.$t("Acoes"), value: "actions", sortable: "false" },
      ],
    };
  },
};
</script>

<style></style>
